import { createCube } from './createCube.js';

export const guidePagesEN = [
  './en/page1.html',
  './en/page2.html',
  './en/page3.html',
  './en/page4.html',
  './en/page5.html',
];
